
    <app-titulo [modulo]="titulo" [mostrar]="true"></app-titulo>
    <div class="container">
      <div class="row">
          <div class="col-lg-3">
            <div class="mb-1 fw-bold">
              <label>Buscar por</label>
          </div>
          <div class="input-group">
              <span class="input-group-text fondo-blanco color-gris cursor" (click)="buscar(texto.value)">
                  <i class="fa-solid fa-magnifying-glass"></i>
              </span>
              <input type="text" class="form-control lineas-buscadores" placeholder="Buscar" #texto id="caja">
              <span class="input-group-text fondo-blanco color-gris cursor" (click)="borrar()" id="cancel">
                  <i class="fa-solid fa-circle-xmark"></i>
              </span>
          </div>
          </div>
      </div>
      <div class="row justify-content-center mt-3">
        <div class="col-lg-12 mt-4">
          <table class="table" aria-describedby="mydesc">
            <thead class="fondo-gris">
                <tr class="text-center">
                    <th scope="col">Nombre del rol</th>
                    <th scope="col">Acciones</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let rol of roles | paginate: { itemsPerPage: 20, currentPage: pagina }" class="text-center">

                    <td *ngIf="dato == rol.idRole" class="d-flex justify-content-center text-center">
                        <input type="text" [(ngModel)]="nuevoNombre" class="form-control w-25 h-25 text-center">
                    </td>
                    <td [ngClass]="{'ocultar': dato == rol.idRole}">{{ rol.description }}</td>
                    <td>
                        <button class="btn btn-primary me-1 btn-edit" *ngIf="dato == rol.idRole" (click)="editarRol(rol.idRole!, nuevoNombre!)">
                            Guardar
                        </button>
                        <button class="btn btn-primary ms-1 btn-edit" *ngIf="dato == rol.idRole" (click)="botonCancelar()">
                            Cancelar
                        </button>
                        <a class="text-primary cursor ms-2 me-5" (click)="mostrarBotones(rol.idRole, rol.description)" *ngIf="rol.isEnabled == true" [ngClass]="{'ocultar': dato == rol.idRole}">
                            <i class="fa fa-marker fa-lg"></i>
                        </a>
                        <a class="text-danger cursor ms-5 me-2" (click)="desactivarRol(rol)" *ngIf="rol.isEnabled == true" [ngClass]="{'ocultar': dato == rol.idRole}">
                            <i class="fa fa-minus-circle fa-lg"></i>
                        </a>
                        <div class="d-flex justify-content-between">
                            <div class="col-3"></div>
                            <a class="text-success col-9" *ngIf="rol.isEnabled == false" (click)="activarRol(rol)">
                                <i class="fa-solid fa-circle-plus fa-lg cursor"></i>
                            </a>
                        </div>
                    </td>
                </tr>
            </tbody>
        </table>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-12">
          <div class="d-flex justify-content-between mt-5">
            <button class="btn btn-outline-primary text-center" (click)="botonesCrearRol()">crear un nuevo rol</button>
            <div *ngIf="mostrar" class="d-flex justify-content-center">
                <input type="text" [(ngModel)]="nuevoRol" class="form-control me-4" placeholder="Nombre rol">
                <div class="d-flex justify-content-center">
                    <button class="btn btn-primary me-4" (click)="crearRol(nuevoRol!)">Crear</button>
                    <button class="btn btn-primary" (click)="cancelarRol()">Cancelar</button>
                </div>
            </div>
            <pagination-controls (pageChange)="pagina = $event" previousLabel="Anterior" nextLabel="Siguiente"></pagination-controls>
        </div>
        </div>
      </div>
    </div>
